import styled from 'styled-components';

const Container = styled.div`
    padding: 0rem 1rem;
    .title-wrapper {
        align-items: center;
        color: #000000;
        display: flex;
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 1rem;
    }
    .apply-icon {
        width: 1.5rem;
        margin-right: 10px;
    }
    .text-content {
        margin-bottom: 1rem;
    }
    .button-container {
        display: flex;
        margin: 1rem 0rem;
        .ant-btn {
            width: 100%;
        }
        .separator {
            margin: 1rem;
        }
    }
`;

export default Container;
